var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricsIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 1.71785L14.5472 4.31899L8.13221 10.7147L5.58466 8.17479L11.9996 1.71785Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.867 5.57362L18.4145 8.17476L8.13221 18.4263L5.58466 15.8864L15.867 5.57362Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26472 9.4294L6.81228 12.0305L4.26472 14.5705L1.71716 12.0305L4.26472 9.4294Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7343 9.4294L22.2819 12.0305L11.9996 22.2821L9.45203 19.7421L19.7343 9.4294Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsIncome);
export default __webpack_public_path__ + "static/media/metrics-income.132bcb65882cff234d32c7067226125e.svg";
export { ForwardRef as ReactComponent };